import { graphql, useStaticQuery } from 'gatsby'

const query = graphql`
	query UseAllPaymentMethodsQuery {
		allPaymentMethod(sort: { fields: [slug] }) {
			nodes {
				id
				name
				slug
				url
				icon
				processors {
					slug
					name
					directIntegration
				}
			}
		}
	}
`

const useAllPaymentMethodsQuery = () => {
	const { allPaymentMethod } = useStaticQuery(query)
	return allPaymentMethod.nodes
}

export default useAllPaymentMethodsQuery
